import { Maybe } from '@wix/wix-data-client-wix-code-adt'
import { appContext } from '../viewer-app-module/DataBindingAppContext'

export const slugResolver = () => () => {
  return Maybe.fromNullable(appContext.platform.location.path).map(
    path => path[path.length - 1],
  )
}
